<div class="edp-select-list mb-4" role="group" ngbDropdown [autoClose]="'outside'" (openChange)="onOpen($event)"
    [placement]="placement" [ngClass]="{ 'top-dropdown': isTopDropdown }">
    <div class="edp-selected" ngbDropdownToggle>
        <input type="text" class="form-control dropdown-input"
            [ngClass]="{'dropdown-input-selected': !!selected}"
            [value]="selected ?  selected :  placeholder | translate"
            placeholder="{{ placeholder | translate}}" readonly>
        <span class="select-icon">
            <i class="icon icon-edponline-Bop-073" [ngClass]="{'icon-selected': !!selected}"  aria-hidden="true"></i>
        </span>
    </div>

    <ul class="select-list" ngbDropdownMenu [ngClass]="{ 'half-height': halfHeight}">
        <li *ngFor="let option of _optionList; let i = index;" ngbDropdownItem class="select-item">
            <div class="d-inline-block" (click)="onChangeOption(option); closeDropdown()">
                <div class="select-item-title">{{option.text}}</div>
                <div class="select-item-description">{{option.description}}</div>
            </div>
        </li>
    </ul>
</div>